import React, { useEffect, useState } from "react";
import { Table, Popover, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { InfoCircleOutlined } from "@ant-design/icons";
import actions from "../../redux/categories/actions";
import { getInterchangeFee, getSwitchingFee } from "../../Helpers/Commision";

// 🔹 Small component just for fee popover
const FeePopover = ({ category, agentChannelRaw, label }) => {
  const [fees, setFees] = React.useState({
    interchange: "N/A",
    switching: "N/A",
  });

  const [pageSize, setPageSize] = useState(50);

  const handleHover = () => {
    const interchange =
      category && agentChannelRaw
        ? getInterchangeFee(category, agentChannelRaw)
        : "N/A";

    const switching = category ? getSwitchingFee(category) : "N/A";

    setFees({ interchange, switching });
  };

  const content = (
    <div
      style={{
        padding: "4px 0",
        color: "black",
        fontSize: "12px",
        minWidth: "200px",
      }}
    >
      <h6 style={{ margin: "0 0 3px 0", fontSize: "15px" }}>
        Commission Details{" "}
      </h6>
      <span style={{ fontSize: "10px" }}> Note: tv(transaction value)</span>
      <p style={{ margin: 0 }}>
        <b>Interchange Fee:</b> {fees.interchange}
      </p>
      <p style={{ margin: 0 }}>
        <b>Switching Fee:</b> {fees.switching}
      </p>
    </div>
  );

  return (
    <div
      style={{ display: "flex", alignItems: "center", gap: "6px" }}
      onMouseEnter={handleHover} // ✅ runs when hovered
    >
      <span>{label}</span>
      <Popover content={content} trigger="hover" placement="right">
        <InfoCircleOutlined
          style={{
            color: "#000000", // ✅ black color
            cursor: "pointer",
            fontSize: "14px",
          }}
        />
      </Popover>
    </div>
  );
};

const Category = () => {
  const profileData = useSelector((state) => state.authReducer.profileData);
  const { agentInformation } = useSelector((state) => state.authReducer);

  const { categoryDetails = [], loading } = useSelector(
    (state) => state?.categoryReducer || {}
  );

  const dispatch = useDispatch();

  const [pageSize, setPageSize] = useState(50);

  useEffect(() => {
    if (profileData?.orgId) {
      dispatch(actions.getCategoryDetails(profileData.orgId));
    }
  }, [dispatch, profileData?.orgId]);

  const columns = [
    { title: "S .NO", dataIndex: "key", key: "key", width: 80 },
    {
      title: "Category Name",
      dataIndex: "categoryName",
      key: "categoryName",
      width: 200,
      render: (value, record) => {
        if (record?.categoryName === "Credit Card") {
          return value; // just show the plain text
        }

        return (
          <FeePopover
            category={record?.categoryName}
            agentChannelRaw={profileData?.orgId}
            label={value}
          />
        );
      },
    },
    {
      title: "Total Transactions",
      dataIndex: "totalTransactionCount",
      key: "totalTransactionCount",
      width: 180,
    },
    {
      title: "Total Amount",
      dataIndex: "totalTransactionAmount",
      key: "totalTransactionAmount",
      width: 180,
      render: (value) =>
        value
          ? `₹ ${(value / 100).toLocaleString("en-IN", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`
          : "₹ 0.00",
    },
    {
      title: "Total Interchange Fee",
      dataIndex: "interchangeFee",
      key: "interchangeFee",
      width: 150,
      render: (value, record) => {
        if (
          value === null ||
          value === undefined ||
          value === 0 ||
          value === "—"
        ) {
          return (
            <div
              style={{
                height: "100%",
              }}
            >
              <span style={{ color: "#999" }}>—</span>
            </div>
          );
        }

        if (record?.categoryName?.toLowerCase() !== "credit card") {
          return `₹ ${Number(value).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        } else {
          return "—";
        }
      },
    },
    {
      title: "Total Switching Fee",
      dataIndex: "switchingFee",
      key: "switchingFee",
      width: 150,
      render: (value, record) => {
        if (
          value === null ||
          value === undefined ||
          value === 0 ||
          value === "—"
        ) {
          return (
            <div
              style={{
                height: "100%",
              }}
            >
              <span style={{ color: "#999" }}>—</span>
            </div>
          );
        }

        if (record?.categoryName?.toLowerCase() !== "credit card") {
          return `₹ ${Number(value).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        } else {
          return "—";
        }
      },
    },

    // {
    //   title: "Total Commission Amount",
    //   dataIndex: "totalCommissionAmount",
    //   key: "totalCommissionAmount",
    //   width: 180,
    //   render: (value, record) => {
    //     const interchangeFee = record.interchangeFee || 0;
    //     const switchingFee = record.switchingFee || 0;
    //     const totalCommission = record.totalCommissionAmount || 0;

    //     if (
    //       value === null ||
    //       value === undefined ||
    //       value === 0 ||
    //       value === "—"
    //     ) {
    //       return (
    //         <div style={{ height: "100%" }}>
    //           <span style={{ color: "#999" }}>—</span>
    //         </div>
    //       );
    //     }
    //     console.log(record, "record");

    //     if (record?.categoryName?.toLowerCase() === "credit card") {
    //       return (
    //         <span style={{ cursor: "pointer" }}>
    //           ₹{" "}
    //           {Number(value).toLocaleString("en-IN", {
    //             minimumFractionDigits: 2,
    //             maximumFractionDigits: 2,
    //           })}
    //         </span>
    //       );
    //     } else {
    //       return (
    //         <Tooltip
    //           placement="top"
    //           overlayInnerStyle={{
    //             background: "white", // ✅ solid white background
    //             border: "1px solid #ddd", // ✅ border for card
    //             borderRadius: "6px",
    //             color: "black",
    //             fontSize: "13px",
    //             padding: "10px",
    //             minWidth: "200px",
    //             boxShadow: "0 2px 8px rgba(0,0,0,0.15)", // ✅ subtle shadow
    //           }}
    //           title={
    //             <div>
    //               <p style={{ margin: 0 }}>IF - SF = C</p>
    //               <p style={{ margin: 0 }}>
    //                 ₹ {interchangeFee} - ₹ {switchingFee} = ₹ {totalCommission}
    //               </p>
    //             </div>
    //           }
    //         >
    //           <span style={{ cursor: "pointer" }}>
    //             ₹{" "}
    //             {Number(value).toLocaleString("en-IN", {
    //               minimumFractionDigits: 2,
    //               maximumFractionDigits: 2,
    //             })}
    //           </span>
    //         </Tooltip>
    //       );
    //     }
    //   },
    // },

    {
      title: `Agent Commission (${agentInformation?.data?.AICommissionPercent}%)`,
      dataIndex: "totalAgentCommission",
      key: "totalAgentCommission",
      width: 180,
      render: (value, record) => {
        const total = record.totalCommissionAmount || 0; // ✅ use correct field

        if (!value || value === "—") {
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <span style={{ color: "#999" }}>—</span>
            </div>
          );
        }

        if (record?.categoryName?.toLowerCase() === "credit card") {
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <span style={{ cursor: "pointer" }}>₹ {value}</span>
            </div>
          );
        } else {
          return (
            <Tooltip
              placement="top"
              color="transparent"
              overlayInnerStyle={{
                background: "transparent",
                boxShadow: "none",
              }}
              title={
                <div
                  style={{
                    padding: "10px",
                    background: "white",
                    border: "1px solid #ddd",
                    borderRadius: "6px",
                    color: "black",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                    fontSize: "13px",
                    minWidth: "200px",
                  }}
                >
                  <h6 style={{ margin: "0 0 6px 0" }}>Agent Commission</h6>
                  <p style={{ margin: 0 }}>
                    {agentInformation?.data?.AICommissionPercent}% of Total
                    Commission : ₹ {total}
                  </p>
                </div>
              }
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <span style={{ cursor: "pointer" }}>₹ {value}</span>
              </div>
            </Tooltip>
          );
        }
      },
    },
  ];

  const dataSource = Array.isArray(categoryDetails)
    ? categoryDetails
        .filter((item) => !["",null,"undefined",undefined]?.includes(item?.categoryName))
        .map((item, index) => ({
          key: index + 1,
          ...item,
        }))
    : [];

  return (
    <div className="mainContain">
      <h3 className="category">Commission History</h3>
      <div className="mt-3">
        <Table
          columns={columns}
          dataSource={dataSource}
          loading={loading}
          scroll={{ x: 1000 }}
          pagination={{
            total: dataSource.length,
            pageSize,
            showSizeChanger: true,
            showQuickJumper: true,
            pageSizeOptions: ["10", "20", "50"],
            onShowSizeChange: (_, size) => setPageSize(size),
          }}
        />
      </div>
    </div>
  );
};

export default Category;
